Object.defineProperty(NodeList.prototype, 'isEmpty', {
    value: function () {
        return this.length === 0;
    }
});